import type { ChartPoint } from "../hooks/use-portfolio-chart";
import { EDGE_THRESHOLD } from "../lib/portfolio-chart-format";

type EdgeSafeLabelArgs = {
	text: string;
	pointTime: number;
	series: ChartPoint[];
	side: "top" | "bottom";
	fill: string;
};

export function createEdgeSafeLabel({
	text,
	pointTime,
	series,
	side,
	fill,
}: EdgeSafeLabelArgs) {
	const first = series[0].t;
	const last = series[series.length - 1].t;
	const span = last - first || 1;
	const ratio = (pointTime - first) / span;
	const nearLeft = ratio <= EDGE_THRESHOLD;
	const nearRight = ratio >= 1 - EDGE_THRESHOLD;

	const textAnchor: "start" | "middle" | "end" = nearLeft
		? "start"
		: nearRight
			? "end"
			: "middle";
	const dx = nearLeft ? 6 : nearRight ? -6 : 0;
	const dy = side === "top" ? -10 : 16;

	return (props: { viewBox?: { x?: number; y?: number } }) => {
		const vb = props.viewBox ?? {};
		const cx = vb.x ?? 0;
		const cy = vb.y ?? 0;
		return (
			<text
				x={cx + dx}
				y={cy + dy}
				textAnchor={textAnchor}
				fill={fill}
				fontSize={11}
				fontWeight={600}
			>
				{text}
			</text>
		);
	};
}
